import { ProtectedRoute } from "../shared/pages/ProtectedRoute";
import { AppLayout } from "../shared/layouts";
import { ROUTES } from "../shared/utils";
import { Dashboard } from "../features/dashboard/Dashboard";

export const homeRoutes = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout title="Dashboard" />,
        children: [{ path: ROUTES.DASHBOARD, element: <Dashboard /> }],
      },
    ],
  },
];
